export default __webpack_public_path__ + "static/media/ParkingEmail.6e2b3529.png";